"use strict";

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFeatureToggles = exports.FeatureTogglesProvider = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importDefault(require("react"));

var FeatureToggles_models_1 = require("./FeatureToggles.models");

var FeatureToggles_functions_1 = require("./FeatureToggles.functions"); // CONTEXT


var FeatureTogglesContext = react_1.default.createContext({}); // PROVIDER

var FeatureTogglesProvider = function FeatureTogglesProvider(_ref) {
  var children = _ref.children,
      applicationName = _ref.applicationName,
      _ref$refreshThreshold = _ref.refreshThreshold,
      refreshThreshold = _ref$refreshThreshold === void 0 ? 1 : _ref$refreshThreshold;

  var _react_1$default$useS = react_1.default.useState(),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      hasMounted = _react_1$default$useS2[0],
      setHasMounted = _react_1$default$useS2[1];

  var _react_1$default$useS3 = react_1.default.useState([]),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      features = _react_1$default$useS4[0],
      setFeatures = _react_1$default$useS4[1];

  var RECALL_THRESHOLD = refreshThreshold; // minutes

  react_1.default.useEffect(function () {
    !!hasMounted && initFeaturesList();
  }, [hasMounted]);
  react_1.default.useEffect(function () {
    setHasMounted(true);
  }, []);

  var isFeatureEnabled = function isFeatureEnabled(featureName) {
    var found = features && features.find(function (featureItem) {
      return (featureItem === null || featureItem === void 0 ? void 0 : featureItem.feature) === featureName;
    });
    return !!(found === null || found === void 0 ? void 0 : found.enabled);
  };
  /**
   *	@description - check if elapsed time (from session) has exceeded threshold
   *  @returns boolean
   */


  var isTimeThresholdExceeded = function isTimeThresholdExceeded() {
    var storedFeatures = (0, FeatureToggles_functions_1.getSessionItem)(FeatureToggles_models_1.Session.features);
    var elapsed = !!storedFeatures ? (0, FeatureToggles_functions_1.elapsedTime)(storedFeatures === null || storedFeatures === void 0 ? void 0 : storedFeatures.time) : {
      milliseconds: 0,
      seconds: 0,
      minutes: 0
    };
    return (elapsed === null || elapsed === void 0 ? void 0 : elapsed.minutes) > RECALL_THRESHOLD || !storedFeatures;
  };
  /**
   *  @description -
   *   if elapsed threshold time has been reached or if stored features are not available,
   *   call the API to get new features list (and then set in session storage)
   */


  var initFeaturesList = function initFeaturesList() {
    var _ref2 = (0, FeatureToggles_functions_1.getSessionItem)(FeatureToggles_models_1.Session.features) || {},
        values = _ref2.values; // if exceed time threshold, get new features via API


    if (isTimeThresholdExceeded() || !values) {
      (0, FeatureToggles_functions_1.getFeaturesList)(applicationName, function (data) {
        //let items = data as FeaturesItems;
        onSuccessFeaturesListResponse(data);
      }, function (error) {});
    } else {
      onSuccessFeaturesListResponse({
        data: {
          features: values
        }
      });
    }
  };
  /**
   * @description - store features list in state and session storage
   * @param data
   */


  var onSuccessFeaturesListResponse = function onSuccessFeaturesListResponse(response) {
    var features = response.data.features;
    setFeatures(features);
    sessionStorage.setItem(FeatureToggles_models_1.Session.features, JSON.stringify({
      time: new Date().toISOString(),
      values: features
    }));
  };

  var exposedProps = {
    isFeatureEnabled: isFeatureEnabled,
    applicationName: applicationName,
    featuresList: features
  };
  return (0, jsx_runtime_1.jsx)(FeatureTogglesContext.Provider, {
    value: exposedProps,
    children: children
  });
};

exports.FeatureTogglesProvider = FeatureTogglesProvider;
exports.default = FeatureTogglesContext;

function useFeatureToggles() {
  return react_1.default.useContext(FeatureTogglesContext);
}

exports.useFeatureToggles = useFeatureToggles;